import { Button } from "@mui/material";
import { Stack } from "@mui/system";
import BrandsFilter from "./BrandsFilter";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setModalOpen,
  setSelectedDataCollectionBrands,
} from "../../../../features/dataCollectionBrandsSlice";
import store from "../../../../store";
import { useEffect } from "react";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";

const BrandsFilterCard = () => {
  const response = useSelector(selectUserData);
  const hasUpdateDataCollectionBrandsPermission = CheckPermissions(
    response?.data?.products?.data_collection,
    "brands",
    "update_brand_data"
  );
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { dataCollectionBrandsList, selectedRows } = useSelector(
    (state: any) => state.dataCollectionBrands
  );

  const clearSelectedDataCollectionBrands = () => {
    dispatch(setSelectedDataCollectionBrands(null)); // Clear the selected DataAccuracy
  };

  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    store.dispatch(setSelectedDataCollectionBrands(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);
  const handleClickOpen = () => {
    if (selectedRows.length > 0) {
      const selectedBrandData = selectedRows.map((brandId: any) => {
        const brandData = dataCollectionBrandsList.find(
          (item: any) => item.brand_id === brandId
        );
        return {
          brandName: brandData ? brandData.brand_name : null,
          brandId: brandId,
          row_output_table_data: brandData?.raw_output_table_name,
        };
      });
      dispatch(setModalOpen({ isOpen: true, data: selectedBrandData }));
    }
  };

  const isRunProcessesEnabled =
    selectedRows.length > 1 &&
    selectedRows.every((brandId: any) => {
      const brandData = dataCollectionBrandsList.find(
        (item: any) => item.brand_id === brandId
      );
      return (
        Array.isArray(brandData?.raw_output_table_name) &&
        brandData.raw_output_table_name.length > 0
      );
    });

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{ width: "100%" }}
    >
      <Stack direction="row" gap={2} alignItems={"center"}>
        <BrandsFilter
          clearSelectedDataCollectionBrands={clearSelectedDataCollectionBrands}
        />
      </Stack>
      <Stack direction="row" gap={2}>
        <Button
          variant="contained"
          color="secondary"
          endIcon={<PlayCircleIcon />}
          disabled={
            !isRunProcessesEnabled || !hasUpdateDataCollectionBrandsPermission
          }
          onClick={() => handleClickOpen()}
          data-tracker="359"
        >
          Run Processes
        </Button>
      </Stack>
    </Stack>
  );
};

export default BrandsFilterCard;
